import React from "react";
import { mergeStyles } from "@fluentui/react/lib/Styling";
import backgroundImage from "../../assets/sanadchat.png";
import chatbotImage from "../../assets/sanad-bot.gif";
import Chat from "../chat/Chat";

const pageContainer = mergeStyles({
  minHeight: "100vh",
  background: "#0A1A2F",
  color: "white",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    opacity: 0.4,
    zIndex: 0,
  },
});

const chatWindowStyles = mergeStyles({
  width: "100%",
  maxWidth: "1200px",
  height: "calc(100vh - 280px)",
  margin: "40px auto",
  background: "rgba(28, 37, 65, 0.95)",
  borderRadius: "16px",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
  backdropFilter: "blur(20px)",
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
});

const botIconContainer = mergeStyles({
  position: "fixed",
  bottom: "24px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "180px",
  height: "180px",
  zIndex: 1,
});

const ChatHome: React.FC = () => {
  const baseUrl = window.location.origin;
  const iframeSrc = `${baseUrl}/`;
  return (
    <div className={pageContainer}>
      <div className={chatWindowStyles}>
        {/* <Chat></Chat> */}
        <iframe src={iframeSrc} height="100%" />
      </div>

      {/* Bot Icon in Footer */}
      <div className={botIconContainer}>
        <img
          src={chatbotImage}
          alt="Chatbot"
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </div>
    </div>
  );
};

export default ChatHome;
